/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import './style/bluemateRadio.scss';

import classNames from 'classnames';

import React, {MouseEventHandler} from 'react';

interface Props {
    onSelect: MouseEventHandler;
    selected: boolean;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function BluemateRadio(props: Props) {
    const {selected, onSelect, className, disabled, label} = props;

    function renderBullet() {
        return (
            <div className='bluemate-radio-bullet-container'>
                <span className={classNames('bluemate-radio-bullet', selected && 'active')} />
            </div>
        );
    }

    function renderLabel() {
        if (!label) return null;
        return <label className='bluemate-radio-label'>{label}</label>;
    }

    return (
        <div
            className={classNames('bluemate-radio', disabled && 'disabled', className)}
            onClick={disabled ? undefined : onSelect}
        >
            {renderBullet()}
            {renderLabel()}
        </div>
    );
}
